import { FilterList, Filters } from 'common/components/AssetBrowser/lib/helpers/enabled_filters';
import { AutocompleteDropdownConfig } from './filter-config';
import { I18n } from 'common/i18n';
import { changeOwner } from 'common/components/AssetBrowser/actions/filters';
import { FilterType } from './types';
import { FilterScope, getScope } from './translations';
import { IBaseListDropdownOption } from '@tylertech/forge/esm/list-dropdown/list-dropdown-constants';
import { getFilteredOptions } from './filter-helper';

const scope = getScope(FilterScope.OwnedBy);

/**
 *  Type inferred from returned data.
 */
export type User = {
  description: string;
  displayName: string;
  domainId: number;
  flags: unknown[];
  id: string;
  memberCount: number;
  members: {
    id: string;
    screen_name: string;
    role_name: 'member';
    flags: unknown;
  }[];
  owners: {
    id: string;
    screen_name: string;
    role_name: 'owner';
    flags: unknown;
  }[];
  screenName: string;
  type: 'user' | 'team';
};

const getOwnedByOptions = (
  input: string,
  list: User[] = [],
  showTeamsOnly?: boolean,
): IBaseListDropdownOption<string | null>[] => {
  const allOptions = list
    .filter((owner) => (showTeamsOnly ? owner.type === 'team' : true))
    .map((user) => ({ label: user.displayName, value: user.id }));

  return getFilteredOptions(allOptions, input);
};

/**
 * selectedOption is the 4x4
 */
const transformOwnedBySelection = (selectedOption: string | null, list: User[] = []) => {
  const obj = list.find((owner) => owner.id === selectedOption);

  return {
    id: obj?.id || '',
    displayName: obj?.displayName || '',
  };
};

export const ownedByConfigs: AutocompleteDropdownConfig<User> = {
  filterName: Filters.OwnedBy,
  label: I18n.t('label', { scope }),
  placeholder: I18n.t('placeholder', { scope }),
  filterCallback: getOwnedByOptions,
  dispatchAction: changeOwner,
  filterType: FilterType.AutocompleteDropdown,
  filterListName: FilterList.UsersList,
  transformSelection: transformOwnedBySelection,
};
